import ServiceReports from '../../../../../services/ServiceReports';

class Service extends ServiceReports {
  constructor() {
    super('/discador');
  }
}

export default new Service();
